module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_03.13ced177.jpg";